export const IconEmailClosedMailingLetters: {
  name: 'icon_email_closed_mailing_letters-a43e2f021194'
} = {
  name: 'icon_email_closed_mailing_letters-a43e2f021194'
}
